import React from "react";
import { useSelector } from "react-redux";
import {
  affiliatesLinkSidebarSelector,
  setAffiliatesLinkSidebarClose,
} from "../../../../store/features/profileSlice";
import { Drawer } from "@mui/material";
import { useAppDispatch } from "../../../../store/store";
import { useTranslation } from "react-i18next";
import { AffiliatesLinkManagementSection } from "./AffiliatesLinkManagementSection";

export const AffiliatesLinkMobileSidebar = () => {
  const { i18n } = useTranslation(["profile"]);
  const dispatch = useAppDispatch();
  const openSideNav = useSelector(affiliatesLinkSidebarSelector);

  const content = <AffiliatesLinkManagementSection />;

  return (
    <Drawer
      transitionDuration={400}
      anchor="top"
      open={openSideNav}
      onClose={() => dispatch(setAffiliatesLinkSidebarClose())}
      PaperProps={{
        sx: {
          backgroundColor: "rgba(255, 255, 255, 1)",
          width: "100%",
          direction: i18n.dir(),
        },
      }}
      BackdropProps={{
        sx: {
          backgroundColor: "transparent",
        },
      }}
      sx={{ zIndex: (theme) => theme.zIndex.appBar + 100 }}
      variant="temporary"
    >
      {content}
    </Drawer>
  );
};
